import { useInfiniteQuery } from '@tanstack/react-query';

import { getLearnBlogPosts } from '@arrived/api_v2';
import { WordpressPostSearchOptions } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { learnBlogKey } from './learnBlog.keys';

export function useGetLearnBlogPostsQuery(
  query?: WordpressPostSearchOptions,
  options?: UseQueryOptions<WordpressPostSearchOptions>
) {
  return useInfiniteQuery(
    learnBlogKey(query),
    ({ pageParam = 1, ...params }) => getLearnBlogPosts({ pageParam, ...params, ...query }),
    {
      staleTime: options?.staleTime ?? MAX_STALE_TIME,
      getPreviousPageParam: (firstPage) => firstPage.prevCursor ?? 0,
      getNextPageParam: (lastPage) => {
        if (lastPage.nextCursor !== null) {
          return lastPage.nextCursor;
        }

        return lastPage;
      },
    }
  );
}
